import EventManager, { preventDefault, stopEvent, stopPropagation } from 'choerodon-ui/lib/_util/EventManager';
export default EventManager;
export { preventDefault, stopPropagation, stopEvent, };
